import * as React from 'react';
import { observer } from 'mobx-react';

import { ErrorMessage } from '../components/error-message/error-message';
import { PanelContentTransition } from '../components/panel-content-transition';
import { getPageClasses } from './helpers/get-page-classes';

import { WebGivingPageViewModel } from './index';

@observer
export class PageError extends React.Component<{
	vm: WebGivingPageViewModel,
	transitionState: string,
}> {
	panelBodyNode: HTMLDivElement;

	render() {
		const { vm, transitionState } = this.props;
		const { error, pageShouldBeVisible, isLoading } = vm;
		const elementsShouldEnter = transitionState === 'entered';

		return (
			<div className={getPageClasses(pageShouldBeVisible, isLoading)} data-pp-at-target={pageShouldBeVisible ? `Error page` : null}>
				<div className="panel-body panel-body-form" ref={this.savePanelBodyNode}>
					<PanelContentTransition in={elementsShouldEnter} setContentHeight={this.setContentHeight} className="panel-body-content">
						<ErrorMessage error={error} />
					</PanelContentTransition>
				</div>
			</div>
		);
	}

	setContentHeight = (offsetHeight: number) => {
		if (this.panelBodyNode) {
			this.panelBodyNode.style.minHeight = `${offsetHeight}px`;
		}
	}

	private savePanelBodyNode = (panelBodyNode: HTMLDivElement) => this.panelBodyNode = panelBodyNode;
}
